import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        name: { type: String },
        date: { type: String },
        participantsCompleted: { type: String },
    },
});
